const ACTION_TYPES = {
  GET_EXAMPLE_DATA: 'GET_EXAMPLE_DATA',
  SET_EXAMPLE_DATA: 'SET_EXAMPLE_DATA',
};

export default ACTION_TYPES;
